/**
 * Elite Fade Designs - Internationalization (i18n)
 * Supports English (en) and Spanish (es)
 */

const translations = {
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      barbers: 'Our Team',
      gallery: 'Gallery',
      about: 'About',
      contact: 'Contact',
      bookNow: 'Book Now',
      signIn: 'Sign In',
      signOut: 'Sign Out',
      myAccount: 'My Account',
      menu: 'Menu',
      main: 'Main navigation',
      mobile: 'Mobile navigation',
      switchLanguage: 'Switch language',
    },

    hero: {
      title: 'Precision Cuts, Premium Style',
      subtitle: 'Experience the art of the perfect fade at Elite Fade Designs. Where style meets precision.',
      cta: 'Book Your Appointment',
      secondary: 'View Our Work',
    },

    services: {
      title: 'Our Services',
      subtitle: 'Premium grooming services tailored to your style',
      haircuts: 'Haircuts',
      fades: 'Fades',
      beards: 'Beard Grooming',
      combos: 'Combo Packages',
      viewAll: 'View All Services',
      duration: 'Duration',
      minutes: 'min',
      bookService: 'Book This Service',
    },

    about: {
      title: 'About Us',
      subtitle: 'More than a barbershop \u2013 a grooming experience',
      story: 'Our Story',
      mission: 'Our Mission',
      team: 'Meet the Team',
    },

    gallery: {
      title: 'Our Work',
      subtitle: 'Browse our portfolio of precision cuts and styles',
      viewMore: 'View More',
    },

    contact: {
      title: 'Get in Touch',
      subtitle: "Have questions? We'd love to hear from you.",
      form: {
        name: 'Your Name',
        email: 'Email Address',
        phone: 'Phone Number',
        message: 'Your Message',
        submit: 'Send Message',
        sending: 'Sending...',
        success: 'Message sent successfully!',
        error: 'Failed to send message. Please try again.',
      },
      info: {
        address: 'Visit Us',
        phone: 'Call Us',
        email: 'Email Us',
        hours: 'Business Hours',
      },
    },

    booking: {
      title: 'Book an Appointment',
      selectService: 'Select a Service',
      selectStaff: 'Choose Your Barber',
      anyStaff: 'Any Available Barber',
      selectDate: 'Select Date',
      selectTime: 'Select Time',
      yourDetails: 'Your Details',
      review: 'Review & Confirm',
      name: 'Full Name',
      email: 'Email Address',
      phone: 'Phone Number',
      notes: 'Special Requests (optional)',
      confirm: 'Confirm Booking',
      processing: 'Processing...',
      success: 'Booking Confirmed!',
      confirmationCode: 'Confirmation Code',
      checkEmail: 'Check your email for details',
      error: 'Booking failed. Please try again.',
      slotUnavailable: 'This time slot is no longer available.',
      back: 'Back',
      next: 'Next',
      flow: {
        header: {
          title: 'Book Appointment',
          stepCount: 'Step {n} of {total}',
        },
        steps: {
          ride: 'Ride',
          location: 'Location',
          barber: 'Barber',
          service: 'Service',
          datetime: 'Date & Time',
          info: 'Your Info',
          done: 'Done',
        },
        common: {
          continue: 'Continue',
          back: 'Back',
          retry: 'Retry',
        },
        step1: {
          label: 'Step 1',
          title: 'Do you need a ride?',
          sub: 'We provide complimentary pickup within Lake County.',
          self: {
            title: "I'll get there myself",
            desc: 'Walk-in, drive, or rideshare',
          },
          yes: {
            title: 'Yes, please pick me up',
            desc: 'Free in Lake County',
          },
          addressLabel: 'Pickup Address',
          addressPlaceholder: 'Start typing your address...',
          valid: 'Great, we serve your area!',
          invalid: 'Sorry, we do not serve outside Lake County.',
        },
        step2: {
          label: 'Step 2',
          title: 'Select a Location',
          sub: 'Choose the shop you would like to visit.',
          onlyBadge: 'Only Location',
          openMaps: 'Open in Maps',
          hours: 'Tue-Sun  9 AM to 9 PM',
        },
        step3: {
          label: 'Step 3',
          title: 'Choose Your Barber',
          sub: 'All barbers are available at {location}.',
          any: 'Any Available',
          anyDesc: 'We will assign the next barber',
          role: 'Barber',
          loadError: 'Could not load barbers. Please try again.',
        },
        step4: {
          label: 'Step 4',
          title: 'Select Services',
          sub: 'Pick one or more. All prices are final.',
          totalOne: '{n} service \u00b7 {price} \u00b7 {duration} min',
          totalMany: '{n} services \u00b7 {price} \u00b7 {duration} min',
          minutes: 'min',
          loadError: 'Could not load services. Please try again.',
          tags: {
            popular: 'Popular',
            bestValue: 'Best Value',
            combo: 'Combo',
            signature: 'Signature',
          },
        },
        step5: {
          label: 'Step 5',
          title: 'Pick a Date and Time',
          sub: 'Available Tue-Sun, 9 AM to 9 PM',
          dateLabel: 'Date',
          timeLabel: 'Time',
          selectDateFirst: 'Select a date first',
          noTimes: 'No times available. Try another date.',
          loadError: 'Could not load times.',
          tryAgain: 'Try again.',
        },
        step6: {
          label: 'Step 6',
          title: 'Your Details',
          sub: 'We will send a confirmation to your email.',
          summary: {
            location: 'Location',
            barber: 'Barber',
            services: 'Services',
            datetime: 'Date and Time',
            ride: 'Ride',
            pickupRequested: 'Pickup requested',
          },
          name: 'Full Name',
          namePh: 'John Smith',
          email: 'Email',
          emailPh: 'john@example.com',
          phone: 'Phone',
          phonePh: '(555) 123-4567',
          notes: 'Notes',
          notesOpt: '(optional)',
          notesPh: 'Any special requests or info for your barber...',
          confirm: 'Confirm Booking',
          confirming: 'Booking...',
          errors: {
            name: 'Please enter your full name.',
            email: 'Please enter a valid email.',
            phone: 'Please enter a valid phone number.',
            slotUnavailable: 'This time slot is no longer available. Please go back and choose another time.',
            validation: 'Please check your information and try again.',
            network: 'Connection issue. Please check your internet and try again.',
            generic: 'Booking failed. Please try again.',
          },
        },
        step7: {
          title: "You're booked!",
          sub: 'A confirmation has been sent to {email}',
          code: 'Confirmation Code',
          summary: {
            location: 'Location',
            barber: 'Barber',
            services: 'Services',
            date: 'Date',
            time: 'Time',
            price: 'Price',
            ride: 'Ride',
          },
          paySuffix: ' \u00b7 Pay at shop',
          pickupAt: 'Pickup at {addr}',
          yourAddress: 'your address',
          directions: 'Get Directions',
          bookAnother: 'Book Another',
          cancelNote: 'Need to cancel? Call us at',
          cancelNoteSuffix: 'at least 2 hours before your appointment.',
        },
      },
    },

    barbers: {
      page: {
        eyebrow: 'Our Team',
        title: 'Meet the Artists<br/>Behind the Chair',
        subtitle: 'Master barbers with the precision, style, and experience to deliver your signature look.',
        ownerBadge: 'Owner',
        certifications: 'Certifications',
        bookWith: 'Book with',
        ctaTitle: 'Ready to look your best?',
        ctaText: 'Pick your barber and book a chair.',
        ctaButton: 'Book Now',
        bioFallback: 'Professional barber at Elite Fade Designs.',
        emptyTitle: 'No barbers yet',
        emptyText: 'Our team will be ready to serve you soon.',
        errorTitle: 'Couldn\u2019t load the team',
        errorText: 'Please refresh the page or try again later.',
      },
      roles: {
        owner: 'Owner & Master Barber',
        senior: 'Senior Barber',
        barber: 'Barber',
      },
      specialties: {
        skinFades: 'Skin Fades',
        beardDesign: 'Beard Design',
        classicCuts: 'Classic Cuts',
        hairDesigns: 'Hair Designs',
        premiumFades: 'Premium Fades',
        lineUps: 'Line-ups',
        kidsCuts: 'Kids Cuts',
        beardTrims: 'Beard Trims',
      },
      certs: {
        ilMaster: 'IL Master Barber License',
        andis: 'Andis Certified',
        ilLicense: 'IL Barber License',
      },
      bios: {
        dennis: 'Founder of Elite Fade Designs. Over a decade of experience specializing in precision fades and Dominican-style cuts. Every chair leaves with a signature look.',
        carlos: 'Senior barber with a passion for modern designs and detailed line work. Known for clean fades and creative custom designs.',
        miguel: 'Skilled barber known for friendly service and exceptional attention to detail. Great with classic cuts, beard work, and the kids.',
      },
    },

    dashboard: {
      auth: {
        title: 'Your Dashboard',
        subtitle: 'Enter your email and confirmation code to access your bookings.',
        emailLabel: 'Email',
        emailPlaceholder: 'you@example.com',
        codeLabel: 'Confirmation Code',
        codePlaceholder: 'e.g. A3X7K9',
        submit: 'Access Dashboard',
        submitting: 'Accessing...',
        error: 'Please enter your email and confirmation code.',
        hint: 'No account needed \u2014 use any confirmation code from a booking.',
        haveAccount: 'Or:',
        signIn: 'Sign in',
        createAccount: 'Create account',
      },
      header: {
        welcome: 'Welcome back',
        bookNow: '+ Book Now',
        signOut: 'Sign Out',
      },
      tabs: {
        upcoming: 'Upcoming',
        history: 'History',
        products: 'Products',
        messages: 'Messages',
        profile: 'Profile',
      },
      upcoming: {
        title: 'Upcoming Appointments',
        empty: 'No upcoming appointments.',
        emptyNew: "You're all set! Book your first appointment to get started.",
        bookNow: 'Book Now',
        cancel: 'Cancel',
        confirmed: 'Confirmed',
        cancelConfirm: 'Cancel this appointment?',
      },
      history: {
        title: 'Appointment History',
        empty: 'No past appointments yet.',
        bookAgain: 'Book Again',
        completed: 'Completed',
        cancelled: 'Cancelled',
      },
      products: { title: 'Recommended for You', askBarber: 'Ask Barber' },
      productTypes: { styling: 'Styling', beard: 'Beard Care', hair: 'Hair Care' },
      productTags: { recommended: 'Recommended', bestSeller: 'Best Seller' },
      messages: {
        title: 'From Your Barber',
        readMore: 'Read more',
        showLess: 'Show less',
        types: { post_service: 'Post Visit', recommendation: 'Recommendation', hair_health: 'Hair Health' },
      },
      profile: {
        title: 'Your Information',
        name: 'Full Name',
        phone: 'Phone',
        email: 'Email',
        emailHint: 'Email cannot be changed',
        memberSince: 'Member Since',
        save: 'Save Changes',
        saved: 'Changes saved.',
      },
      myBarber: {
        title: 'My Barber',
        change: 'Change',
        cancel: 'Cancel',
        changeTitle: 'Change Your Barber',
        emptyTitle: 'Choose Your Favorite Barber',
        emptyText: 'Pick a go-to barber for faster booking and personalized recommendations.',
        chooseBtn: 'Choose Barber',
      },
    },

    expb: {
      header: {
        eyebrow: 'Quick Book',
        title: 'Hey, {name}',
        sub: 'Pick services and a time. Your barber and details are already set.',
      },
      barber: {
        label: 'Your barber',
        change: 'Change',
      },
      services: {
        title: 'Services',
        sub: 'Choose one or more.',
        minutes: 'min',
      },
      datetime: {
        title: 'Date & Time',
        dateLabel: 'Date',
        timeLabel: 'Time',
        pickServicesFirst: 'Choose services first.',
        pickDateFirst: 'Pick a date to see times.',
        noSlots: 'No times available for this date. Try another.',
      },
      notes: {
        title: 'Notes',
        optional: '(optional)',
        placeholder: 'Anything your barber should know?',
      },
      phone: {
        title: 'Phone number',
        sub: 'We need this to reach you about your appointment.',
        placeholder: '(555) 123-4567',
        errorRequired: 'Please enter your phone number.',
        errorInvalid: 'Please enter a valid phone number.',
      },
      cta: {
        empty: 'Pick services to continue.',
        totalOne: '{n} service \u00b7 {price} \u00b7 {duration} min',
        totalMany: '{n} services \u00b7 {price} \u00b7 {duration} min',
        confirm: 'Confirm Booking',
        booking: 'Booking...',
        hint: 'Pay at shop. Cancel up to 2 hours before your appointment.',
      },
      confirm: {
        title: "You're booked!",
        sub: 'A confirmation has been sent to {email}.',
        codeLabel: 'Confirmation code',
        barber: 'Barber',
        services: 'Services',
        date: 'Date',
        time: 'Time',
        total: 'Total',
        viewDash: 'View in Dashboard',
      },
      errors: {
        title: 'Switch to the full flow',
        notSignedIn: "We couldn't find your session. Please sign in again.",
        noFavorite: "You haven't set a preferred barber yet.",
        barberMissing: "Your preferred barber isn't available right now.",
        loadFailed: "Couldn't load your booking options. Please try again.",
        availFailed: "Couldn't load available times.",
        slotTaken: 'That time was just taken. Pick another slot.',
        bookingFailed: "Couldn't complete your booking. Please try again.",
        useFullFlow: 'Continue with full booking',
      },
    },

    auth: {
      common: {
        backToSite: 'Back to site',
      },
      signUp: {
        title: 'Create your account',
        subtitle: 'Save time on bookings, view your history, and get personalized service.',
        name: 'Full name',
        namePh: 'John Smith',
        email: 'Email',
        emailPh: 'you@example.com',
        phone: 'Phone',
        phonePh: '(555) 123-4567',
        optional: '(optional)',
        password: 'Password',
        passwordPh: 'Choose a strong password',
        passwordHint: 'At least 8 characters with one uppercase, one lowercase, and one number.',
        createAccount: 'Create account',
        creating: 'Creating account...',
        alreadyHave: 'Already have an account?',
        signIn: 'Sign in',
        confirmTitle: 'Verify your email',
        confirmSub: 'We sent a 6-digit code to {email}. Enter it below to finish setting up your account.',
        codeLabel: 'Verification code',
        confirm: 'Verify and continue',
        confirming: 'Verifying...',
        resend: 'Resend code',
        resendIn: 'Resend in {s}s',
        changeEmail: 'Use a different email',
        errors: {
          name: 'Please enter your full name.',
          email: 'Please enter a valid email.',
          phone: 'Please enter a valid phone number.',
          passwordShort: 'Password must be at least 8 characters.',
          passwordUpper: 'Password must include an uppercase letter.',
          passwordLower: 'Password must include a lowercase letter.',
          passwordNumber: 'Password must include a number.',
          passwordPolicy: "Password doesn't meet the requirements.",
          invalidCode: 'Code must be 6 digits.',
          emailTaken: 'An account with this email already exists. Try signing in instead.',
          codeMismatch: 'Incorrect code. Please try again.',
          codeExpired: 'Code expired. Tap "Resend code" to get a new one.',
          invalidInput: 'Please check your information and try again.',
          rateLimited: 'Too many attempts. Please wait a moment and try again.',
          generic: 'Something went wrong. Please try again.',
        },
      },
      signIn: {
        title: 'Welcome back',
        subtitle: 'Sign in to view your bookings and account.',
        email: 'Email',
        emailPh: 'you@example.com',
        password: 'Password',
        passwordPh: 'Your password',
        signIn: 'Sign in',
        signingIn: 'Signing in...',
        forgot: 'Forgot password?',
        noAccount: "Don't have an account?",
        createAccount: 'Sign up',
        errors: {
          email: 'Please enter a valid email.',
          password: 'Please enter your password.',
          badCredentials: 'Email or password is incorrect.',
          notConfirmed: 'Account not verified yet. Check your email for the verification code, or sign up again to resend it.',
          codeMismatch: 'Incorrect code. Please try again.',
          codeExpired: 'Code expired. Request a new one.',
          rateLimited: 'Too many attempts. Please wait a moment and try again.',
          generic: 'Sign in failed. Please try again.',
        },
        forgotFlow: {
          title: 'Reset your password',
          subtitle: "Enter your email and we'll send you a code to reset it.",
          sendCode: 'Send reset code',
          sending: 'Sending...',
          backToLogin: 'Back to sign in',
          confirmTitle: 'Set a new password',
          confirmSub: 'Enter the 6-digit code sent to {email} and choose a new password.',
          codeLabel: 'Reset code',
          newPassword: 'New password',
          newPasswordPh: 'Choose a strong password',
          reset: 'Reset password',
          resetting: 'Resetting...',
        },
      },
    },

    login: {
      title: 'Sign in to Admin',
      subtitle: 'Access restricted to authorized staff.',
      email: 'Email',
      password: 'Password',
      submit: 'Sign in',
      back: 'Back to website',
      errors: {
        required: 'Email and password are required.',
        noAccess: 'This account does not have admin access.',
      },
    },

    footer: {
      tagline: 'Premium barbershop delivering precision cuts and exceptional grooming experiences.',
      quickLinks: 'Quick Links',
      services: 'Services',
      contact: 'Contact',
      rights: 'All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      legal: 'Legal links',
    },

    common: {
      loading: 'Loading...',
      error: 'Something went wrong',
      retry: 'Try Again',
      close: 'Close',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      search: 'Search',
      noResults: 'No results found',
      required: 'Required',
      optional: 'Optional',
    },

    validation: {
      required: 'This field is required',
      email: 'Please enter a valid email',
      phone: 'Please enter a valid phone number',
      minLength: 'Must be at least {min} characters',
      maxLength: 'Must be no more than {max} characters',
    },

    // ====================================================================
    // ADMIN PORTAL
    // ====================================================================
    admin: {
      common: {
        retry: 'Retry',
        cancel: 'Cancel',
        save: 'Save',
        saving: 'Saving...',
        close: 'Close',
        delete: 'Delete',
        edit: 'Edit',
        new: 'New',
        add: 'Add',
        remove: 'Remove',
        all: 'All',
        loading: 'Loading...',
        unsavedChanges: 'Unsaved changes',
      },

      sidebar: {
        groups: { dashboard: 'Dashboard', operations: 'Operations', catalog: 'Catalog' },
        items: {
          overview: 'Overview', bookings: 'Bookings', schedule: 'Schedule',
          rides: 'Rides', conversations: 'Conversations', clients: 'Clients',
          services: 'Services', staff: 'Staff',
        },
        soon: 'Soon',
        signOut: 'Sign out',
      },

      topbar: {
        roles: { admin: 'Admin', staff: 'Staff', dispatcher: 'Dispatcher', user: 'User' },
        openMenu: 'Open menu',
        closeMenu: 'Close menu',
      },

      pageTitles: {
        overview: 'Overview', bookings: 'Bookings', schedule: 'Schedule',
        rides: 'Rides', services: 'Services', staff: 'Staff',
        conversations: 'Conversations', clients: 'Clients', notFound: 'Not found',
      },

      placeholders: {
        notFound: "That admin page doesn't exist.",
        schedule: 'Staff schedule editor is coming soon.',
        rides: 'Dispatch board is coming soon.',
        services: 'Service catalog editor is coming soon.',
        staff: 'Staff manager is coming soon.',
        conversations: 'Coming with the chat module.',
        clients: 'Customer CRM with notes, messages, and recommendations is coming.',
      },

      dashboard: {
        stats: {
          todayBookings: "Today's bookings",
          revenueToday: 'Revenue today',
          thisWeek: 'This week',
          cancellationsToday: 'Cancellations today',
          confirmedDone: '{confirmed} confirmed, {completed} done',
          revenueSub: '{amount} revenue',
          reviewWithStaff: 'Review with staff',
          allClear: 'All clear',
        },
        upcoming: {
          title: 'Upcoming bookings',
          viewAll: 'View all',
          empty: 'No upcoming bookings.',
        },
        error: { title: "Couldn't load dashboard" },
      },

      bookings: {
        tabs: { today: 'Today', week: 'This week', all: 'All', date: 'By date' },
        filters: {
          allStatuses: 'All statuses',
          confirmed: 'Confirmed', completed: 'Completed',
          cancelled: 'Cancelled', noShow: 'No-show',
          refresh: 'Refresh',
        },
        columns: { booking: 'Booking', when: 'When', status: 'Status' },
        statusBadges: {
          confirmed: 'Confirmed', completed: 'Completed',
          cancelled: 'Cancelled', no_show: 'No-show',
        },
        empty: 'No bookings match your filters.',
        error: { title: "Couldn't load bookings" },
        detail: {
          title: 'Booking',
          when: 'When', code: 'Code', email: 'Email', phone: 'Phone', notes: 'Notes',
          actions: {
            cancelBooking: 'Cancel booking',
            markNoShow: 'Mark no-show',
            markCompleted: 'Mark completed',
          },
          cancelPrompt: 'Cancellation reason (optional):',
        },
      },

      services: {
        toolbar: {
          countOne: '{count} service',
          countMany: '{count} services',
          newService: '+ New service',
        },
        modal: {
          new: 'New service',
          edit: 'Edit service',
          fields: {
            nameEn: 'Name (English)',
            nameEs: 'Name (Spanish)',
            descEn: 'Description (English)',
            descEs: 'Description (Spanish)',
            price: 'Price (USD)',
            duration: 'Duration (min)',
            category: 'Category',
            sortOrder: 'Sort order',
            active: 'Active',
            imageUrl: 'Image URL',
          },
          actions: { create: 'Create service', save: 'Save changes' },
        },
        validation: {
          nameRequired: 'Name is required.',
          pricePositive: 'Price must be greater than 0.',
          durationMin: 'Duration must be at least 5 minutes.',
        },
        deleteConfirm: 'Delete "{name}"? It will be hidden from public listings.',
        empty: { title: 'No services yet.', create: '+ Create first service' },
        error: {
          title: "Couldn't load services",
          saveFailed: 'Save failed',
          deleteFailed: 'Delete failed',
        },
      },

      staff: {
        toolbar: {
          countOne: '{count} member',
          countMany: '{count} members',
          newStaff: '+ New staff member',
        },
        card: { inactive: 'Inactive', driverTitle: 'Available as driver' },
        modal: {
          new: 'New staff member',
          edit: 'Edit staff member',
          photoNote: 'Photo upload coming soon.',
          fields: {
            name: 'Full name',
            role: 'Role',
            addCustom: '+ Add custom role...',
            customRolePlaceholder: 'Enter new role',
            email: 'Email',
            phone: 'Phone',
            bioEn: 'Bio (English)',
            bioEs: 'Bio (Spanish)',
            specialties: 'Specialties',
            specialtiesHint: 'Press Enter or comma to add',
            specialtiesPlaceholder: 'e.g. fade, beard, design',
            specialtiesAria: 'Add specialty',
            active: 'Active',
            isDriver: 'Available as driver',
          },
          actions: { create: 'Create staff member', save: 'Save changes' },
          removeChip: 'Remove',
        },
        validation: {
          nameRequired: 'Name is required.',
          roleRequired: 'Role is required.',
        },
        deleteConfirm: 'Delete "{name}"? They will be hidden from public listings.',
        empty: { title: 'No staff members yet.', create: '+ Add first member' },
        error: {
          title: "Couldn't load staff",
          saveFailed: 'Save failed',
          deleteFailed: 'Delete failed',
        },
      },

      schedule: {
        loading: 'Loading staff...',
        staffSelect: 'Staff member',
        noStaff: 'No active staff members. Add staff first to manage their schedule.',
        defaults: {
          title: 'Default weekly schedule',
          sub: 'Standard hours for every week. Date overrides below take precedence.',
          save: 'Save schedule',
        },
        days: {
          monday: 'Monday', tuesday: 'Tuesday', wednesday: 'Wednesday',
          thursday: 'Thursday', friday: 'Friday', saturday: 'Saturday', sunday: 'Sunday',
        },
        day: {
          off: 'Day off',
          noBreaks: 'No breaks',
          breakLabel: 'Break',
          addBreak: '+ Add break',
          removeBreak: 'Remove break',
        },
        overrides: {
          title: 'Date overrides \u00b7 next 30 days',
          sub: 'Mark vacations, adjust hours for specific dates, or block individual time slots.',
          add: '+ Add override',
          empty: 'No overrides for the next 30 days. Default schedule applies.',
          badges: {
            dayOff: 'Day off',
            blockedSlotOne: '{count} slot blocked',
            blockedSlotMany: '{count} slots blocked',
            custom: 'Custom',
          },
        },
        modal: {
          add: 'Add date override',
          edit: 'Edit override',
          fields: {
            date: 'Date',
            working: 'Working that day',
            customStart: 'Custom start',
            customEnd: 'Custom end',
            defaultHint: 'leave empty to use default',
            blockedSlots: 'Blocked slots',
            blockedSlotsHint: 'comma-separated, e.g. 12:00, 12:30',
            notes: 'Notes',
            notesHint: 'internal only',
          },
          actions: {
            add: 'Add override',
            save: 'Save',
            remove: 'Remove',
          },
          confirmRemove: 'Remove override for {date}? Default schedule will apply.',
        },
        validation: {
          dateRequired: 'Date is required.',
          endAfterStart: 'End time must be after start time.',
        },
        error: {
          title: "Couldn't load schedule",
          saveFailed: 'Save failed',
          removeFailed: 'Remove failed',
        },
      },

      rides: {
        tabs: { active: 'Active', completed: 'Completed', all: 'All' },
        toolbar: { refresh: 'Refresh', newRide: '+ New ride' },
        columns: { route: 'Route', when: 'When', driver: 'Driver', status: 'Status' },
        unassigned: 'Unassigned',
        statusBadges: {
          requested: 'Requested', assigned: 'Assigned',
          en_route: 'En route', arrived: 'Arrived',
          completed: 'Completed', cancelled: 'Cancelled',
        },
        empty: {
          active: 'No active rides right now.',
          completed: 'No completed rides yet.',
          all: 'No rides yet.',
        },
        error: { title: "Couldn't load rides" },
        detail: {
          title: 'Ride request',
          pickup: 'Pickup',
          driver: 'Driver',
          passengers: 'Passengers',
          notes: 'Notes',
          activity: 'Activity',
          historyEmpty: 'No history yet.',
          historyError: "Couldn't load activity.",
        },
        history: {
          rideRequested: 'Ride requested',
          statusChanged: 'Status changed to {to}',
          driverAssigned: 'Driver assigned',
          driverAssignedTo: 'Driver assigned: {name}',
          update: 'Update',
        },
        assign: {
          label: 'Assign driver',
          placeholder: 'Select driver...',
          assign: 'Assign',
          reassign: 'Reassign',
          noDrivers: 'No drivers available. Mark a staff member as "Available as driver" first.',
          chooseFirst: 'Choose a driver first.',
        },
        actions: {
          cancelRide: 'Cancel ride',
          markEnRoute: 'Mark en route',
          markArrived: 'Mark arrived',
          markCompleted: 'Mark completed',
          cancelPrompt: 'Cancellation reason (optional):',
          assignFailed: 'Assignment failed',
          actionFailed: 'Action failed',
        },
        newModal: {
          title: 'New ride request',
          fields: {
            pickupAddress: 'Pickup address',
            dropoffAddress: 'Drop-off address',
            pickupTime: 'Pickup time',
            passengers: 'Passengers',
            notes: 'Notes',
            notesHint: 'internal only',
          },
          submit: 'Create ride',
          createFailed: 'Create failed',
        },
        validation: {
          pickupShort: 'Pickup address must be at least 10 characters.',
          dropoffShort: 'Drop-off address must be at least 10 characters.',
          timeRequired: 'Pickup time is required.',
          timeFuture: 'Pickup time must be in the future.',
        },
      },
    },
  },

  // ========================================================================
  // SPANISH
  // ========================================================================
  es: {
    nav: {
      home: 'Inicio',
      services: 'Servicios',
      barbers: 'Nuestro Equipo',
      gallery: 'Galer\u00eda',
      about: 'Nosotros',
      contact: 'Contacto',
      bookNow: 'Reservar',
      signIn: 'Iniciar sesi\u00f3n',
      signOut: 'Cerrar sesi\u00f3n',
      myAccount: 'Mi Cuenta',
      menu: 'Men\u00fa',
      main: 'Navegaci\u00f3n principal',
      mobile: 'Navegaci\u00f3n m\u00f3vil',
      switchLanguage: 'Cambiar idioma',
    },

    hero: {
      title: 'Cortes Precisos, Estilo Premium',
      subtitle: 'Experimenta el arte del degradado perfecto en Elite Fade Designs. Donde el estilo se encuentra con la precisi\u00f3n.',
      cta: 'Reserva Tu Cita',
      secondary: 'Ver Nuestro Trabajo',
    },

    services: {
      title: 'Nuestros Servicios',
      subtitle: 'Servicios de est\u00e9tica premium adaptados a tu estilo',
      haircuts: 'Cortes de Cabello',
      fades: 'Degradados',
      beards: 'Arreglo de Barba',
      combos: 'Paquetes Combo',
      viewAll: 'Ver Todos los Servicios',
      duration: 'Duraci\u00f3n',
      minutes: 'min',
      bookService: 'Reservar Este Servicio',
    },

    about: {
      title: 'Sobre Nosotros',
      subtitle: 'M\u00e1s que una barber\u00eda \u2013 una experiencia de est\u00e9tica',
      story: 'Nuestra Historia',
      mission: 'Nuestra Misi\u00f3n',
      team: 'Conoce al Equipo',
    },

    gallery: {
      title: 'Nuestro Trabajo',
      subtitle: 'Explora nuestro portafolio de cortes y estilos de precisi\u00f3n',
      viewMore: 'Ver M\u00e1s',
    },

    contact: {
      title: 'Cont\u00e1ctanos',
      subtitle: '\u00bfTienes preguntas? Nos encantar\u00eda escucharte.',
      form: {
        name: 'Tu Nombre',
        email: 'Correo Electr\u00f3nico',
        phone: 'N\u00famero de Tel\u00e9fono',
        message: 'Tu Mensaje',
        submit: 'Enviar Mensaje',
        sending: 'Enviando...',
        success: '\u00a1Mensaje enviado exitosamente!',
        error: 'Error al enviar mensaje. Por favor intenta de nuevo.',
      },
      info: {
        address: 'Vis\u00edtanos',
        phone: 'Ll\u00e1manos',
        email: 'Escr\u00edbenos',
        hours: 'Horario de Atenci\u00f3n',
      },
    },

    booking: {
      title: 'Reservar una Cita',
      selectService: 'Selecciona un Servicio',
      selectStaff: 'Elige Tu Barbero',
      anyStaff: 'Cualquier Barbero Disponible',
      selectDate: 'Selecciona Fecha',
      selectTime: 'Selecciona Hora',
      yourDetails: 'Tus Datos',
      review: 'Revisar y Confirmar',
      name: 'Nombre Completo',
      email: 'Correo Electr\u00f3nico',
      phone: 'N\u00famero de Tel\u00e9fono',
      notes: 'Solicitudes Especiales (opcional)',
      confirm: 'Confirmar Reserva',
      processing: 'Procesando...',
      success: '\u00a1Reserva Confirmada!',
      confirmationCode: 'C\u00f3digo de Confirmaci\u00f3n',
      checkEmail: 'Revisa tu correo para los detalles',
      error: 'Error en la reserva. Por favor intenta de nuevo.',
      slotUnavailable: 'Este horario ya no est\u00e1 disponible.',
      back: 'Atr\u00e1s',
      next: 'Siguiente',
      flow: {
        header: {
          title: 'Reservar Cita',
          stepCount: 'Paso {n} de {total}',
        },
        steps: {
          ride: 'Transporte',
          location: 'Ubicaci\u00f3n',
          barber: 'Barbero',
          service: 'Servicio',
          datetime: 'Fecha y Hora',
          info: 'Tus Datos',
          done: 'Listo',
        },
        common: {
          continue: 'Continuar',
          back: 'Atr\u00e1s',
          retry: 'Reintentar',
        },
        step1: {
          label: 'Paso 1',
          title: '\u00bfNecesitas transporte?',
          sub: 'Ofrecemos recogida gratuita en Lake County.',
          self: {
            title: 'Yo llego por mi cuenta',
            desc: 'A pie, en carro o rideshare',
          },
          yes: {
            title: 'S\u00ed, rec\u00f3genme por favor',
            desc: 'Gratis en Lake County',
          },
          addressLabel: 'Direcci\u00f3n de recogida',
          addressPlaceholder: 'Empieza a escribir tu direcci\u00f3n...',
          valid: '\u00a1Excelente, servimos tu \u00e1rea!',
          invalid: 'Lo sentimos, no servimos fuera de Lake County.',
        },
        step2: {
          label: 'Paso 2',
          title: 'Selecciona una Ubicaci\u00f3n',
          sub: 'Elige la barber\u00eda que quieres visitar.',
          onlyBadge: '\u00danica Ubicaci\u00f3n',
          openMaps: 'Abrir en Maps',
          hours: 'Mar-Dom  9 AM a 9 PM',
        },
        step3: {
          label: 'Paso 3',
          title: 'Elige Tu Barbero',
          sub: 'Todos los barberos est\u00e1n disponibles en {location}.',
          any: 'Cualquiera Disponible',
          anyDesc: 'Asignaremos al pr\u00f3ximo barbero',
          role: 'Barbero',
          loadError: 'No se pudieron cargar los barberos. Intenta de nuevo.',
        },
        step4: {
          label: 'Paso 4',
          title: 'Selecciona Servicios',
          sub: 'Elige uno o m\u00e1s. Todos los precios son finales.',
          totalOne: '{n} servicio \u00b7 {price} \u00b7 {duration} min',
          totalMany: '{n} servicios \u00b7 {price} \u00b7 {duration} min',
          minutes: 'min',
          loadError: 'No se pudieron cargar los servicios. Intenta de nuevo.',
          tags: {
            popular: 'Popular',
            bestValue: 'Mejor Valor',
            combo: 'Combo',
            signature: 'Insignia',
          },
        },
        step5: {
          label: 'Paso 5',
          title: 'Elige Fecha y Hora',
          sub: 'Disponible Mar-Dom, 9 AM a 9 PM',
          dateLabel: 'Fecha',
          timeLabel: 'Hora',
          selectDateFirst: 'Selecciona una fecha primero',
          noTimes: 'No hay horarios disponibles. Prueba otra fecha.',
          loadError: 'No se pudieron cargar los horarios.',
          tryAgain: 'Intenta de nuevo.',
        },
        step6: {
          label: 'Paso 6',
          title: 'Tus Datos',
          sub: 'Te enviaremos una confirmaci\u00f3n a tu correo.',
          summary: {
            location: 'Ubicaci\u00f3n',
            barber: 'Barbero',
            services: 'Servicios',
            datetime: 'Fecha y Hora',
            ride: 'Transporte',
            pickupRequested: 'Recogida solicitada',
          },
          name: 'Nombre Completo',
          namePh: 'Juan P\u00e9rez',
          email: 'Correo',
          emailPh: 'tu@ejemplo.com',
          phone: 'Tel\u00e9fono',
          phonePh: '(555) 123-4567',
          notes: 'Notas',
          notesOpt: '(opcional)',
          notesPh: 'Solicitudes especiales o info para tu barbero...',
          confirm: 'Confirmar Reserva',
          confirming: 'Reservando...',
          errors: {
            name: 'Por favor ingresa tu nombre completo.',
            email: 'Por favor ingresa un correo v\u00e1lido.',
            phone: 'Por favor ingresa un tel\u00e9fono v\u00e1lido.',
            slotUnavailable: 'Este horario ya no est\u00e1 disponible. Vuelve atr\u00e1s y elige otro.',
            validation: 'Por favor revisa tu informaci\u00f3n e intenta de nuevo.',
            network: 'Problema de conexi\u00f3n. Revisa tu internet e intenta de nuevo.',
            generic: 'La reserva fall\u00f3. Por favor intenta de nuevo.',
          },
        },
        step7: {
          title: '\u00a1Reserva confirmada!',
          sub: 'Se envi\u00f3 una confirmaci\u00f3n a {email}',
          code: 'C\u00f3digo de Confirmaci\u00f3n',
          summary: {
            location: 'Ubicaci\u00f3n',
            barber: 'Barbero',
            services: 'Servicios',
            date: 'Fecha',
            time: 'Hora',
            price: 'Precio',
            ride: 'Transporte',
          },
          paySuffix: ' \u00b7 Pagar en la barber\u00eda',
          pickupAt: 'Recogida en {addr}',
          yourAddress: 'tu direcci\u00f3n',
          directions: 'C\u00f3mo Llegar',
          bookAnother: 'Reservar Otra',
          cancelNote: '\u00bfNecesitas cancelar? Ll\u00e1manos al',
          cancelNoteSuffix: 'al menos 2 horas antes de tu cita.',
        },
      },
    },

    barbers: {
      page: {
        eyebrow: 'Nuestro Equipo',
        title: 'Conoce a los Artistas<br/>Detr\u00e1s de la Silla',
        subtitle: 'Barberos maestros con la precisi\u00f3n, estilo y experiencia para entregarte tu look de firma.',
        ownerBadge: 'Due\u00f1o',
        certifications: 'Certificaciones',
        bookWith: 'Reservar con',
        ctaTitle: '\u00bfListo para verte mejor que nunca?',
        ctaText: 'Elige tu barbero y reserva tu silla.',
        ctaButton: 'Reservar',
        bioFallback: 'Barbero profesional en Elite Fade Designs.',
        emptyTitle: 'Sin barberos disponibles',
        emptyText: 'Nuestro equipo estar\u00e1 listo para atenderte pronto.',
        errorTitle: 'No pudimos cargar el equipo',
        errorText: 'Por favor recarga la p\u00e1gina o int\u00e9ntalo m\u00e1s tarde.',
      },
      roles: {
        owner: 'Due\u00f1o y Barbero Maestro',
        senior: 'Barbero Senior',
        barber: 'Barbero',
      },
      specialties: {
        skinFades: 'Degradados a Piel',
        beardDesign: 'Dise\u00f1o de Barba',
        classicCuts: 'Cortes Cl\u00e1sicos',
        hairDesigns: 'Dise\u00f1os de Cabello',
        premiumFades: 'Degradados Premium',
        lineUps: 'Perfilados',
        kidsCuts: 'Cortes para Ni\u00f1os',
        beardTrims: 'Recorte de Barba',
      },
      certs: {
        ilMaster: 'Licencia de Barbero Maestro IL',
        andis: 'Certificado Andis',
        ilLicense: 'Licencia de Barbero IL',
      },
      bios: {
        dennis: 'Fundador de Elite Fade Designs. M\u00e1s de una d\u00e9cada de experiencia especializ\u00e1ndose en degradados de precisi\u00f3n y cortes al estilo dominicano. Cada cliente sale con un look de firma.',
        carlos: 'Barbero senior apasionado por los dise\u00f1os modernos y el trabajo detallado de l\u00edneas. Reconocido por degradados limpios y dise\u00f1os personalizados creativos.',
        miguel: 'Barbero experto reconocido por su servicio amable y atenci\u00f3n excepcional al detalle. Excelente con cortes cl\u00e1sicos, trabajo de barba y los ni\u00f1os.',
      },
    },

    dashboard: {
      auth: {
        title: 'Tu Panel',
        subtitle: 'Ingresa tu correo y c\u00f3digo de confirmaci\u00f3n para acceder a tus citas.',
        emailLabel: 'Correo',
        emailPlaceholder: 'tu@ejemplo.com',
        codeLabel: 'C\u00f3digo de Confirmaci\u00f3n',
        codePlaceholder: 'ej. A3X7K9',
        submit: 'Acceder al Panel',
        submitting: 'Accediendo...',
        error: 'Por favor ingresa tu correo y c\u00f3digo de confirmaci\u00f3n.',
        hint: 'No necesitas cuenta \u2014 usa cualquier c\u00f3digo de confirmaci\u00f3n de una reserva.',
        haveAccount: 'O:',
        signIn: 'Iniciar sesi\u00f3n',
        createAccount: 'Crear cuenta',
      },
      header: {
        welcome: 'Bienvenido de vuelta',
        bookNow: '+ Reservar',
        signOut: 'Cerrar Sesi\u00f3n',
      },
      tabs: {
        upcoming: 'Pr\u00f3ximas',
        history: 'Historial',
        products: 'Productos',
        messages: 'Mensajes',
        profile: 'Perfil',
      },
      upcoming: {
        title: 'Pr\u00f3ximas Citas',
        empty: 'No tienes citas pr\u00f3ximas.',
        emptyNew: '\u00a1Listo! Reserva tu primera cita para empezar.',
        bookNow: 'Reservar',
        cancel: 'Cancelar',
        confirmed: 'Confirmada',
        cancelConfirm: '\u00bfCancelar esta cita?',
      },
      history: {
        title: 'Historial de Citas',
        empty: 'A\u00fan no tienes citas pasadas.',
        bookAgain: 'Reservar de Nuevo',
        completed: 'Completada',
        cancelled: 'Cancelada',
      },
      products: { title: 'Recomendados para Ti', askBarber: 'Preguntar al Barbero' },
      productTypes: { styling: 'Estilismo', beard: 'Cuidado de Barba', hair: 'Cuidado del Cabello' },
      productTags: { recommended: 'Recomendado', bestSeller: 'M\u00e1s Vendido' },
      messages: {
        title: 'De Tu Barbero',
        readMore: 'Leer m\u00e1s',
        showLess: 'Mostrar menos',
        types: { post_service: 'Post Visita', recommendation: 'Recomendaci\u00f3n', hair_health: 'Salud Capilar' },
      },
      profile: {
        title: 'Tu Informaci\u00f3n',
        name: 'Nombre Completo',
        phone: 'Tel\u00e9fono',
        email: 'Correo',
        emailHint: 'El correo no se puede cambiar',
        memberSince: 'Miembro Desde',
        save: 'Guardar Cambios',
        saved: 'Cambios guardados.',
      },
      myBarber: {
        title: 'Mi Barbero',
        change: 'Cambiar',
        cancel: 'Cancelar',
        changeTitle: 'Cambia Tu Barbero',
        emptyTitle: 'Elige Tu Barbero Favorito',
        emptyText: 'Elige un barbero de cabecera para reservar m\u00e1s r\u00e1pido y recibir recomendaciones personalizadas.',
        chooseBtn: 'Elegir Barbero',
      },
    },

    expb: {
      header: {
        eyebrow: 'Reserva R\u00e1pida',
        title: 'Hola, {name}',
        sub: 'Elige servicios y horario. Tu barbero y datos ya est\u00e1n listos.',
      },
      barber: {
        label: 'Tu barbero',
        change: 'Cambiar',
      },
      services: {
        title: 'Servicios',
        sub: 'Elige uno o m\u00e1s.',
        minutes: 'min',
      },
      datetime: {
        title: 'Fecha y Hora',
        dateLabel: 'Fecha',
        timeLabel: 'Hora',
        pickServicesFirst: 'Elige servicios primero.',
        pickDateFirst: 'Elige una fecha para ver horarios.',
        noSlots: 'No hay horarios disponibles para esta fecha. Prueba otra.',
      },
      notes: {
        title: 'Notas',
        optional: '(opcional)',
        placeholder: '\u00bfAlgo que tu barbero deba saber?',
      },
      phone: {
        title: 'Tel\u00e9fono',
        sub: 'Lo necesitamos para contactarte sobre tu cita.',
        placeholder: '(555) 123-4567',
        errorRequired: 'Por favor ingresa tu n\u00famero.',
        errorInvalid: 'Por favor ingresa un n\u00famero v\u00e1lido.',
      },
      cta: {
        empty: 'Elige servicios para continuar.',
        totalOne: '{n} servicio \u00b7 {price} \u00b7 {duration} min',
        totalMany: '{n} servicios \u00b7 {price} \u00b7 {duration} min',
        confirm: 'Confirmar Reserva',
        booking: 'Reservando...',
        hint: 'Pagar en la barber\u00eda. Puedes cancelar hasta 2 horas antes.',
      },
      confirm: {
        title: '\u00a1Reserva confirmada!',
        sub: 'Se envi\u00f3 una confirmaci\u00f3n a {email}.',
        codeLabel: 'C\u00f3digo de confirmaci\u00f3n',
        barber: 'Barbero',
        services: 'Servicios',
        date: 'Fecha',
        time: 'Hora',
        total: 'Total',
        viewDash: 'Ver en mi Panel',
      },
      errors: {
        title: 'Continuar con el flujo completo',
        notSignedIn: 'No encontramos tu sesi\u00f3n. Inicia sesi\u00f3n de nuevo.',
        noFavorite: 'A\u00fan no has elegido un barbero favorito.',
        barberMissing: 'Tu barbero favorito no est\u00e1 disponible ahora.',
        loadFailed: 'No se pudo cargar la informaci\u00f3n. Intenta de nuevo.',
        availFailed: 'No se pudieron cargar los horarios disponibles.',
        slotTaken: 'Ese horario acaba de ser tomado. Elige otro.',
        bookingFailed: 'No se pudo completar tu reserva. Intenta de nuevo.',
        useFullFlow: 'Continuar con la reserva completa',
      },
    },

    auth: {
      common: {
        backToSite: 'Volver al sitio',
      },
      signUp: {
        title: 'Crea tu cuenta',
        subtitle: 'Ahorra tiempo al reservar, ve tu historial y recibe servicio personalizado.',
        name: 'Nombre completo',
        namePh: 'Juan P\u00e9rez',
        email: 'Correo',
        emailPh: 'tu@ejemplo.com',
        phone: 'Tel\u00e9fono',
        phonePh: '(555) 123-4567',
        optional: '(opcional)',
        password: 'Contrase\u00f1a',
        passwordPh: 'Elige una contrase\u00f1a segura',
        passwordHint: 'M\u00ednimo 8 caracteres con una may\u00fascula, una min\u00fascula y un n\u00famero.',
        createAccount: 'Crear cuenta',
        creating: 'Creando cuenta...',
        alreadyHave: '\u00bfYa tienes cuenta?',
        signIn: 'Iniciar sesi\u00f3n',
        confirmTitle: 'Verifica tu correo',
        confirmSub: 'Enviamos un c\u00f3digo de 6 d\u00edgitos a {email}. Ingr\u00e9salo abajo para terminar de crear tu cuenta.',
        codeLabel: 'C\u00f3digo de verificaci\u00f3n',
        confirm: 'Verificar y continuar',
        confirming: 'Verificando...',
        resend: 'Reenviar c\u00f3digo',
        resendIn: 'Reenviar en {s}s',
        changeEmail: 'Usar otro correo',
        errors: {
          name: 'Por favor ingresa tu nombre completo.',
          email: 'Por favor ingresa un correo v\u00e1lido.',
          phone: 'Por favor ingresa un tel\u00e9fono v\u00e1lido.',
          passwordShort: 'La contrase\u00f1a debe tener al menos 8 caracteres.',
          passwordUpper: 'La contrase\u00f1a debe incluir una may\u00fascula.',
          passwordLower: 'La contrase\u00f1a debe incluir una min\u00fascula.',
          passwordNumber: 'La contrase\u00f1a debe incluir un n\u00famero.',
          passwordPolicy: 'La contrase\u00f1a no cumple los requisitos.',
          invalidCode: 'El c\u00f3digo debe tener 6 d\u00edgitos.',
          emailTaken: 'Ya existe una cuenta con ese correo. Intenta iniciar sesi\u00f3n.',
          codeMismatch: 'C\u00f3digo incorrecto. Intenta de nuevo.',
          codeExpired: 'El c\u00f3digo expir\u00f3. Toca "Reenviar c\u00f3digo" para uno nuevo.',
          invalidInput: 'Por favor revisa tu informaci\u00f3n e intenta de nuevo.',
          rateLimited: 'Demasiados intentos. Espera un momento e intenta de nuevo.',
          generic: 'Algo sali\u00f3 mal. Intenta de nuevo.',
        },
      },
      signIn: {
        title: 'Bienvenido de vuelta',
        subtitle: 'Inicia sesi\u00f3n para ver tus reservas y tu cuenta.',
        email: 'Correo',
        emailPh: 'tu@ejemplo.com',
        password: 'Contrase\u00f1a',
        passwordPh: 'Tu contrase\u00f1a',
        signIn: 'Iniciar sesi\u00f3n',
        signingIn: 'Iniciando sesi\u00f3n...',
        forgot: '\u00bfOlvidaste tu contrase\u00f1a?',
        noAccount: '\u00bfNo tienes cuenta?',
        createAccount: 'Reg\u00edstrate',
        errors: {
          email: 'Por favor ingresa un correo v\u00e1lido.',
          password: 'Por favor ingresa tu contrase\u00f1a.',
          badCredentials: 'Correo o contrase\u00f1a incorrectos.',
          notConfirmed: 'Tu cuenta a\u00fan no est\u00e1 verificada. Revisa tu correo o reg\u00edstrate de nuevo para reenviar el c\u00f3digo.',
          codeMismatch: 'C\u00f3digo incorrecto. Intenta de nuevo.',
          codeExpired: 'El c\u00f3digo expir\u00f3. Solicita uno nuevo.',
          rateLimited: 'Demasiados intentos. Espera un momento e intenta de nuevo.',
          generic: 'No se pudo iniciar sesi\u00f3n. Intenta de nuevo.',
        },
        forgotFlow: {
          title: 'Restablecer contrase\u00f1a',
          subtitle: 'Ingresa tu correo y te enviaremos un c\u00f3digo para restablecerla.',
          sendCode: 'Enviar c\u00f3digo',
          sending: 'Enviando...',
          backToLogin: 'Volver a iniciar sesi\u00f3n',
          confirmTitle: 'Establece una nueva contrase\u00f1a',
          confirmSub: 'Ingresa el c\u00f3digo de 6 d\u00edgitos enviado a {email} y elige una nueva contrase\u00f1a.',
          codeLabel: 'C\u00f3digo',
          newPassword: 'Nueva contrase\u00f1a',
          newPasswordPh: 'Elige una contrase\u00f1a segura',
          reset: 'Restablecer contrase\u00f1a',
          resetting: 'Restableciendo...',
        },
      },
    },

    login: {
      title: 'Acceder al Panel',
      subtitle: 'Acceso restringido a personal autorizado.',
      email: 'Correo electr\u00f3nico',
      password: 'Contrase\u00f1a',
      submit: 'Iniciar sesi\u00f3n',
      back: 'Volver al sitio',
      errors: {
        required: 'El correo y la contrase\u00f1a son obligatorios.',
        noAccess: 'Esta cuenta no tiene acceso al panel.',
      },
    },

    footer: {
      tagline: 'Barber\u00eda premium que ofrece cortes de precisi\u00f3n y experiencias de est\u00e9tica excepcionales.',
      quickLinks: 'Enlaces R\u00e1pidos',
      services: 'Servicios',
      contact: 'Contacto',
      rights: 'Todos los derechos reservados.',
      privacy: 'Pol\u00edtica de Privacidad',
      terms: 'T\u00e9rminos de Servicio',
      legal: 'Enlaces legales',
    },

    common: {
      loading: 'Cargando...',
      error: 'Algo sali\u00f3 mal',
      retry: 'Intentar de Nuevo',
      close: 'Cerrar',
      cancel: 'Cancelar',
      save: 'Guardar',
      delete: 'Eliminar',
      edit: 'Editar',
      view: 'Ver',
      search: 'Buscar',
      noResults: 'No se encontraron resultados',
      required: 'Requerido',
      optional: 'Opcional',
    },

    validation: {
      required: 'Este campo es requerido',
      email: 'Por favor ingresa un correo v\u00e1lido',
      phone: 'Por favor ingresa un tel\u00e9fono v\u00e1lido',
      minLength: 'Debe tener al menos {min} caracteres',
      maxLength: 'Debe tener m\u00e1ximo {max} caracteres',
    },

    // ====================================================================
    // PORTAL ADMIN
    // ====================================================================
    admin: {
      common: {
        retry: 'Reintentar',
        cancel: 'Cancelar',
        save: 'Guardar',
        saving: 'Guardando...',
        close: 'Cerrar',
        delete: 'Eliminar',
        edit: 'Editar',
        new: 'Nuevo',
        add: 'Agregar',
        remove: 'Quitar',
        all: 'Todos',
        loading: 'Cargando...',
        unsavedChanges: 'Cambios sin guardar',
      },

      sidebar: {
        groups: { dashboard: 'Panel', operations: 'Operaciones', catalog: 'Cat\u00e1logo' },
        items: {
          overview: 'Resumen', bookings: 'Reservas', schedule: 'Horarios',
          rides: 'Viajes', conversations: 'Conversaciones', clients: 'Clientes',
          services: 'Servicios', staff: 'Equipo',
        },
        soon: 'Pronto',
        signOut: 'Cerrar sesi\u00f3n',
      },

      topbar: {
        roles: { admin: 'Admin', staff: 'Personal', dispatcher: 'Despachador', user: 'Usuario' },
        openMenu: 'Abrir men\u00fa',
        closeMenu: 'Cerrar men\u00fa',
      },

      pageTitles: {
        overview: 'Resumen', bookings: 'Reservas', schedule: 'Horarios',
        rides: 'Viajes', services: 'Servicios', staff: 'Equipo',
        conversations: 'Conversaciones', clients: 'Clientes', notFound: 'No encontrado',
      },

      placeholders: {
        notFound: 'Esa p\u00e1gina del admin no existe.',
        schedule: 'Editor de horarios pr\u00f3ximamente.',
        rides: 'Tablero de despacho pr\u00f3ximamente.',
        services: 'Editor de servicios pr\u00f3ximamente.',
        staff: 'Gestor de personal pr\u00f3ximamente.',
        conversations: 'Llega con el m\u00f3dulo de chat.',
        clients: 'CRM de clientes con notas, mensajes y recomendaciones pr\u00f3ximamente.',
      },

      dashboard: {
        stats: {
          todayBookings: 'Reservas de hoy',
          revenueToday: 'Ingresos de hoy',
          thisWeek: 'Esta semana',
          cancellationsToday: 'Cancelaciones hoy',
          confirmedDone: '{confirmed} confirmadas, {completed} listas',
          revenueSub: '{amount} en ingresos',
          reviewWithStaff: 'Revisar con el equipo',
          allClear: 'Todo bien',
        },
        upcoming: {
          title: 'Pr\u00f3ximas reservas',
          viewAll: 'Ver todas',
          empty: 'No hay pr\u00f3ximas reservas.',
        },
        error: { title: 'No se pudo cargar el panel' },
      },

      bookings: {
        tabs: { today: 'Hoy', week: 'Esta semana', all: 'Todas', date: 'Por fecha' },
        filters: {
          allStatuses: 'Todos los estados',
          confirmed: 'Confirmadas', completed: 'Completadas',
          cancelled: 'Canceladas', noShow: 'No vino',
          refresh: 'Actualizar',
        },
        columns: { booking: 'Reserva', when: 'Cu\u00e1ndo', status: 'Estado' },
        statusBadges: {
          confirmed: 'Confirmada', completed: 'Completada',
          cancelled: 'Cancelada', no_show: 'No vino',
        },
        empty: 'Ninguna reserva coincide con los filtros.',
        error: { title: 'No se pudieron cargar las reservas' },
        detail: {
          title: 'Reserva',
          when: 'Cu\u00e1ndo', code: 'C\u00f3digo', email: 'Correo', phone: 'Tel\u00e9fono', notes: 'Notas',
          actions: {
            cancelBooking: 'Cancelar reserva',
            markNoShow: 'Marcar no vino',
            markCompleted: 'Marcar completada',
          },
          cancelPrompt: 'Raz\u00f3n de cancelaci\u00f3n (opcional):',
        },
      },

      services: {
        toolbar: {
          countOne: '{count} servicio',
          countMany: '{count} servicios',
          newService: '+ Nuevo servicio',
        },
        modal: {
          new: 'Nuevo servicio',
          edit: 'Editar servicio',
          fields: {
            nameEn: 'Nombre (Ingl\u00e9s)',
            nameEs: 'Nombre (Espa\u00f1ol)',
            descEn: 'Descripci\u00f3n (Ingl\u00e9s)',
            descEs: 'Descripci\u00f3n (Espa\u00f1ol)',
            price: 'Precio (USD)',
            duration: 'Duraci\u00f3n (min)',
            category: 'Categor\u00eda',
            sortOrder: 'Orden',
            active: 'Activo',
            imageUrl: 'URL de imagen',
          },
          actions: { create: 'Crear servicio', save: 'Guardar cambios' },
        },
        validation: {
          nameRequired: 'El nombre es obligatorio.',
          pricePositive: 'El precio debe ser mayor a 0.',
          durationMin: 'La duraci\u00f3n debe ser al menos 5 minutos.',
        },
        deleteConfirm: '\u00bfEliminar "{name}"? Se ocultar\u00e1 del sitio p\u00fablico.',
        empty: { title: 'A\u00fan no hay servicios.', create: '+ Crear primer servicio' },
        error: {
          title: 'No se pudieron cargar los servicios',
          saveFailed: 'No se pudo guardar',
          deleteFailed: 'No se pudo eliminar',
        },
      },

      staff: {
        toolbar: {
          countOne: '{count} miembro',
          countMany: '{count} miembros',
          newStaff: '+ Nuevo miembro',
        },
        card: { inactive: 'Inactivo', driverTitle: 'Disponible como conductor' },
        modal: {
          new: 'Nuevo miembro',
          edit: 'Editar miembro',
          photoNote: 'Subida de foto pr\u00f3ximamente.',
          fields: {
            name: 'Nombre completo',
            role: 'Rol',
            addCustom: '+ Agregar rol personalizado...',
            customRolePlaceholder: 'Escribe el nuevo rol',
            email: 'Correo',
            phone: 'Tel\u00e9fono',
            bioEn: 'Bio (Ingl\u00e9s)',
            bioEs: 'Bio (Espa\u00f1ol)',
            specialties: 'Especialidades',
            specialtiesHint: 'Presiona Enter o coma para agregar',
            specialtiesPlaceholder: 'ej. fade, barba, dise\u00f1o',
            specialtiesAria: 'Agregar especialidad',
            active: 'Activo',
            isDriver: 'Disponible como conductor',
          },
          actions: { create: 'Crear miembro', save: 'Guardar cambios' },
          removeChip: 'Quitar',
        },
        validation: {
          nameRequired: 'El nombre es obligatorio.',
          roleRequired: 'El rol es obligatorio.',
        },
        deleteConfirm: '\u00bfEliminar a "{name}"? Se ocultar\u00e1 del sitio p\u00fablico.',
        empty: { title: 'A\u00fan no hay miembros.', create: '+ Agregar primer miembro' },
        error: {
          title: 'No se pudo cargar el equipo',
          saveFailed: 'No se pudo guardar',
          deleteFailed: 'No se pudo eliminar',
        },
      },

      schedule: {
        loading: 'Cargando equipo...',
        staffSelect: 'Miembro del equipo',
        noStaff: 'No hay miembros activos. Agrega personal primero para gestionar su horario.',
        defaults: {
          title: 'Horario semanal por defecto',
          sub: 'Horas est\u00e1ndar para cada semana. Las excepciones por fecha tienen prioridad.',
          save: 'Guardar horario',
        },
        days: {
          monday: 'Lunes', tuesday: 'Martes', wednesday: 'Mi\u00e9rcoles',
          thursday: 'Jueves', friday: 'Viernes', saturday: 'S\u00e1bado', sunday: 'Domingo',
        },
        day: {
          off: 'Libre',
          noBreaks: 'Sin descansos',
          breakLabel: 'Descanso',
          addBreak: '+ Agregar descanso',
          removeBreak: 'Quitar descanso',
        },
        overrides: {
          title: 'Excepciones por fecha \u00b7 pr\u00f3ximos 30 d\u00edas',
          sub: 'Marca vacaciones, ajusta horas para fechas espec\u00edficas o bloquea horarios individuales.',
          add: '+ Agregar excepci\u00f3n',
          empty: 'Sin excepciones para los pr\u00f3ximos 30 d\u00edas. Aplica el horario por defecto.',
          badges: {
            dayOff: 'Libre',
            blockedSlotOne: '{count} horario bloqueado',
            blockedSlotMany: '{count} horarios bloqueados',
            custom: 'Personalizado',
          },
        },
        modal: {
          add: 'Agregar excepci\u00f3n',
          edit: 'Editar excepci\u00f3n',
          fields: {
            date: 'Fecha',
            working: 'Trabaja ese d\u00eda',
            customStart: 'Inicio personalizado',
            customEnd: 'Fin personalizado',
            defaultHint: 'deja vac\u00edo para usar el por defecto',
            blockedSlots: 'Horarios bloqueados',
            blockedSlotsHint: 'separa con comas, ej. 12:00, 12:30',
            notes: 'Notas',
            notesHint: 'solo internas',
          },
          actions: {
            add: 'Agregar excepci\u00f3n',
            save: 'Guardar',
            remove: 'Quitar',
          },
          confirmRemove: '\u00bfQuitar excepci\u00f3n para {date}? Aplicar\u00e1 el horario por defecto.',
        },
        validation: {
          dateRequired: 'La fecha es obligatoria.',
          endAfterStart: 'La hora de fin debe ser despu\u00e9s del inicio.',
        },
        error: {
          title: 'No se pudo cargar el horario',
          saveFailed: 'No se pudo guardar',
          removeFailed: 'No se pudo quitar',
        },
      },

      rides: {
        tabs: { active: 'Activos', completed: 'Completados', all: 'Todos' },
        toolbar: { refresh: 'Actualizar', newRide: '+ Nuevo viaje' },
        columns: { route: 'Ruta', when: 'Cu\u00e1ndo', driver: 'Conductor', status: 'Estado' },
        unassigned: 'Sin asignar',
        statusBadges: {
          requested: 'Solicitado', assigned: 'Asignado',
          en_route: 'En ruta', arrived: 'Lleg\u00f3',
          completed: 'Completado', cancelled: 'Cancelado',
        },
        empty: {
          active: 'No hay viajes activos.',
          completed: 'A\u00fan no hay viajes completados.',
          all: 'A\u00fan no hay viajes.',
        },
        error: { title: 'No se pudieron cargar los viajes' },
        detail: {
          title: 'Solicitud de viaje',
          pickup: 'Recogida',
          driver: 'Conductor',
          passengers: 'Pasajeros',
          notes: 'Notas',
          activity: 'Actividad',
          historyEmpty: 'A\u00fan no hay actividad.',
          historyError: 'No se pudo cargar la actividad.',
        },
        history: {
          rideRequested: 'Viaje solicitado',
          statusChanged: 'Estado cambiado a {to}',
          driverAssigned: 'Conductor asignado',
          driverAssignedTo: 'Conductor asignado: {name}',
          update: 'Actualizaci\u00f3n',
        },
        assign: {
          label: 'Asignar conductor',
          placeholder: 'Selecciona conductor...',
          assign: 'Asignar',
          reassign: 'Reasignar',
          noDrivers: 'No hay conductores disponibles. Marca un miembro como "Disponible como conductor" primero.',
          chooseFirst: 'Elige un conductor primero.',
        },
        actions: {
          cancelRide: 'Cancelar viaje',
          markEnRoute: 'Marcar en ruta',
          markArrived: 'Marcar lleg\u00f3',
          markCompleted: 'Marcar completado',
          cancelPrompt: 'Raz\u00f3n de cancelaci\u00f3n (opcional):',
          assignFailed: 'No se pudo asignar',
          actionFailed: 'No se pudo realizar la acci\u00f3n',
        },
        newModal: {
          title: 'Nueva solicitud de viaje',
          fields: {
            pickupAddress: 'Direcci\u00f3n de recogida',
            dropoffAddress: 'Direcci\u00f3n de destino',
            pickupTime: 'Hora de recogida',
            passengers: 'Pasajeros',
            notes: 'Notas',
            notesHint: 'solo internas',
          },
          submit: 'Crear viaje',
          createFailed: 'No se pudo crear',
        },
        validation: {
          pickupShort: 'La direcci\u00f3n de recogida debe tener al menos 10 caracteres.',
          dropoffShort: 'La direcci\u00f3n de destino debe tener al menos 10 caracteres.',
          timeRequired: 'La hora de recogida es obligatoria.',
          timeFuture: 'La hora de recogida debe ser en el futuro.',
        },
      },
    },
  },
};

let currentLanguage = 'en';

export function getCurrentLanguage() {
  return currentLanguage;
}

export function setLanguage(lang) {
  if (translations[lang]) {
    currentLanguage = lang;
    localStorage.setItem('efd-language', lang);
    document.documentElement.lang = lang;
    window.dispatchEvent(new CustomEvent('languageChange', { detail: { language: lang } }));
  }
}

export function t(keyPath, params = {}) {
  const keys = keyPath.split('.');
  let value = translations[currentLanguage];

  for (const key of keys) {
    if (value && typeof value === 'object') {
      value = value[key];
    } else {
      value = keys.reduce((obj, k) => obj?.[k], translations.en);
      break;
    }
  }

  if (typeof value === 'string' && Object.keys(params).length > 0) {
    return value.replace(/\{(\w+)\}/g, (_, key) => params[key] ?? `{${key}}`);
  }

  return value || keyPath;
}

export function initI18n() {
  const savedLang = localStorage.getItem('efd-language');
  const browserLang = navigator.language.split('-')[0];
  const initialLang = savedLang || (translations[browserLang] ? browserLang : 'en');
  setLanguage(initialLang);
}

initI18n();

export default { t, getCurrentLanguage, setLanguage, initI18n };
